const formattingOptions = {
  hour12: true,
  hour: 'numeric',
  minute: 'numeric',
  month: 'long',
  day: '2-digit',
}

const getOrdinal = (n) => {
  n = +n
  var s = ['th', 'st', 'nd', 'rd'],
    v = n % 100
  return n + (s[(v - 20) % 10] || s[v] || s[0])
}

export const formatDetectionDatetime = (utc) => {
  if (!utc) return ''
  //const str = new Date(utc).toLocaleString('en-US', formattingOptions)
  const str = new Intl.DateTimeFormat('en-US', { dateStyle: 'long', timeStyle: 'medium' }).format(new Date(utc));
  return str
  // const [date, time] = str.split(', ')
  // const [month, dd] = date.split(' ')
  // return [`${time.toLocaleUpperCase()},`, month, `${getOrdinal(dd)}`].join(' ')
}

// Threat Feed (PIXMC-6746) wants "Sep 21, 2026 at 6:14 PM" — short month, 12-hour, no
// seconds. Kept separate from formatDetectionDatetime (used by ~28 legacy screens) so those
// screens keep their existing long-month / with-seconds format. Built from explicit parts
// because no single Intl dateStyle/timeStyle combo yields short-month + "at" + no-seconds.
export const formatThreatFeedDatetime = (utc) => {
  if (!utc) return ''
  const d = new Date(utc)
  const date = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).format(d)
  const time = new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }).format(d)
  return `${date} at ${time}`
}

export const getUTCDate = (span) => {
  let date = new Date()
  date.setDate(date.getDate() - span)
  return date.toISOString().slice(0, -1).replace('T', ' ')
}
